import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SellableProduct } from '@shared/classes/sellable-product';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-nameless-activation-modal',
    templateUrl: './nameless-activation-modal.component.html',
    styleUrls: ['./nameless-activation-modal.component.scss'],
    imports: [TranslateModule]
})
export class NamelessActivationModalComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  modalRef = inject(BsModalRef);
  options = inject(ModalOptions);


  routerListener: Subscription;
  suggestedProducts : SellableProduct[] = [];

  ngOnInit() {
    // this.suggestedProducts = this.options.initialState['suggestedProducts'];
     if (this.modalRef.content && 'suggestedProducts' in this.modalRef.content) {
      this.suggestedProducts = this.modalRef.content['suggestedProducts'];
    }

    this.routerListener = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onClose();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerListener.unsubscribe();
  }

  onClose() {
    this.modalRef.hide();
  }

}
